(function(){
  var CDN="https://cdn.shopify.com/s/files/1/0541/4499/1401/files/";
  var PRODUCTS={
    fv:{cat:"Daily Nutrition",name:"Fruits & Veggies Superfood",img:CDN+"Bottle_Front.webp",handle:"fruits-and-veggies",
        desc:"Cover your daily nutrition gaps with whole-food fruits and greens in one simple scoop."},
    reds:{cat:"Energy & Vitality",name:"Daily Reds Energy Blend",img:CDN+"Reds_Product.webp",handle:"raw-reds",
        desc:"Natural, antioxidant-rich energy — without the caffeine crash."},
    elec:{cat:"Clean Hydration",name:"Clean Hydration Electrolyte Mix",img:CDN+"Electrolytes_Front.webp",handle:"electrolytes",
        desc:"Clean hydration with real minerals — no sugar, no lurid dyes."},
    colo:{cat:"Gut & Immunity",name:"Pure Bovine Colostrum",img:CDN+"Colostrum_Product.webp",handle:"colostrum",
        desc:"Grass-fed colostrum to support your gut, immunity, and everyday vitality."},
    coll:{cat:"Healthy Aging",name:"Daily Multi-Collagen Formula",img:CDN+"Collagen_Product.webp",handle:"multi-collagen-capsules",
        desc:"Five collagen types for youthful skin, hair, nails, joints, and bones."},
    joint:{cat:"Movement & Recovery",name:"Daily Joint & Mobility Formula",img:CDN+"Joint_Front.webp",handle:"joint-support",
        desc:"Targeted support to keep you moving comfortably and doing more."}
  };
  // tie-break priority (earlier wins)
  var PRIORITY=["fv","reds","elec","colo","coll","joint"];

  var quiz=document.getElementById('quiz');
  if(!quiz)return;
  var PBASE=quiz.getAttribute('data-product-base')||"/products/";
  var SHOPALL=quiz.getAttribute('data-shop-all')||"/collections/all";
  var steps=Array.prototype.slice.call(quiz.querySelectorAll('.q-step'));
  var TOTAL=steps.length;
  var answers=new Array(TOTAL).fill(null);
  var cur=0;
  var bar=document.getElementById('bar'),plabel=document.getElementById('plabel');
  var backBtn=document.getElementById('backBtn'),nextBtn=document.getElementById('nextBtn');
  var card=document.getElementById('questionCard'),result=document.getElementById('result');

  function render(){
    steps.forEach(function(s,i){s.classList.toggle('active',i===cur);});
    bar.style.width=((cur)/TOTAL*100)+'%';
    plabel.textContent='Question '+(cur+1)+' of '+TOTAL;
    backBtn.disabled=cur===0;
    nextBtn.disabled=!answers[cur];
    nextBtn.textContent=(cur===TOTAL-1)?'See my result →':'Next →';
    // reflect stored selection
    steps[cur].querySelectorAll('.opt').forEach(function(o){
      o.classList.toggle('sel',answers[cur]&&o.getAttribute('data-score')===answers[cur]);
    });
  }
  steps.forEach(function(step,i){
    step.querySelectorAll('.opt').forEach(function(opt){
      opt.addEventListener('click',function(){
        answers[i]=opt.getAttribute('data-score');
        step.querySelectorAll('.opt').forEach(function(o){o.classList.remove('sel');});
        opt.classList.add('sel');
        nextBtn.disabled=false;
      });
    });
  });
  backBtn.addEventListener('click',function(){if(cur>0){cur--;render();window.scrollTo({top:0,behavior:'smooth'});}});
  nextBtn.addEventListener('click',function(){
    if(!answers[cur])return;
    if(cur<TOTAL-1){cur++;render();window.scrollTo({top:0,behavior:'smooth'});}
    else finish();
  });

  function finish(){
    var score={fv:0,reds:0,elec:0,colo:0,coll:0,joint:0};
    answers.forEach(function(a){
      if(!a)return;
      a.split(',').forEach(function(pair){
        if(!pair)return;
        var kv=pair.split(':');score[kv[0]]=(score[kv[0]]||0)+parseInt(kv[1],10);
      });
    });
    var best=PRIORITY[0],bestv=-1;
    PRIORITY.forEach(function(k){if(score[k]>bestv){bestv=score[k];best=k;}});
    var p=PRODUCTS[best];
    document.getElementById('rImg').src=p.img;
    document.getElementById('rImg').alt=p.name;
    document.getElementById('rCat').textContent=p.cat;
    document.getElementById('rName').textContent=p.name;
    document.getElementById('rDesc').textContent=p.desc;
    document.getElementById('rShop').href=PBASE+p.handle;
    document.getElementById('rShop').textContent='Shop '+p.name.split(' ').slice(0,2).join(' ');
    document.getElementById('rAll').href=SHOPALL;
    bar.style.width='100%';plabel.textContent='Done';
    card.style.display='none';result.classList.add('active');
    window.scrollTo({top:0,behavior:'smooth'});
  }
  document.getElementById('restartBtn').addEventListener('click',function(){
    answers=new Array(TOTAL).fill(null);cur=0;
    result.classList.remove('active');card.style.display='';
    steps.forEach(function(s){s.querySelectorAll('.opt').forEach(function(o){o.classList.remove('sel');});});
    render();window.scrollTo({top:0,behavior:'smooth'});
  });
  render();
})();
